// O dono e o relógio de uma escrita, lidos no INSTANTE da ação (AP-116, sonda OC do
// cybersec, 29/09/2026).
//
// O dono se grava no instante da captura. As escritas do local-db (posição, "já vi",
// recálculo do `series_progress`, favoritos, perfis) só chamavam o sync DEPOIS do
// `await` do IndexedDB. Com o `put` pendurado durante um sign-out e o pareamento de B, a
// escrita de A virava entrada de B, e o flush de B criava "Perfil da A" na conta de B.
// Agora cada escrita captura o dono e o relógio na ENTRADA, antes de qualquer `await`, e
// passa a captura até a fachada do sync (sync/index.ts). Uma escrita de A que termina com
// B logada entra no outbox com o dono A: espera A voltar (o flush só manda o do dono da
// sessão). O relógio também é o da ação, não o de quando o IDB respondeu.
//
// Módulo próprio (e não a fachada) de propósito: o local-db o importa direto, e as
// suítes que substituem a fachada inteira continuam valendo.

import { getSwipeUserId } from './swipe-session'

/** O dono (conta Swipe da sessão, ou null sem sessão) e o relógio (ms) da escrita. */
export interface WriteCapture {
  owner: string | null
  at: number
}

/** Chame na ENTRADA da escrita, antes de qualquer `await`. */
export function captureWrite(): WriteCapture {
  return { owner: getSwipeUserId(), at: Date.now() }
}
